export default "__VITE_ASSET__8HRFjlEv__"